module.exports = __webpack_public_path__ + "img/title_bg_zizhuxuexi_1840.bb1b1a0c.png";